module.exports = __webpack_public_path__ + "assets/img/0264.1a5c0d6e.svg";